<template>
  <div class="bdc-table-footer-wrap">
    <div v-if="isBdc" class="bdc-table-footer">
      <div v-if="$slots.actions" class="bdc-table-footer__actions">
        <slot name="actions" />
      </div>
      <div class="bdc-table-footer__pagination">
        <slot />
      </div>
    </div>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'BdcTableFooter',
  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    }
  }
}
</script>
